<template>
    <div class="product-detail">
      <h2 v-if="!isReview">{{currObj.title}}</h2>
      <div class="image-container wp-relative">
        <div class="big-image">
          <swiper 
          :modules="modules" 
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
          :loop="true"
          :slides-per-view="1" 
          :pagination="{ clickable: true }"
          @swiper="onBigSwiper"
          @slideChange="onSlideChange">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <el-image  
              :class="{ active: activeIndex === index }"
              @click="setActiveImage(index)"
              alt="Product Image" 
              :src="image"
              :fit="contain"></el-image>
              <!-- <img :src="image" :class="{ active: activeIndex === index }"  alt="Product Image" @click="setActiveImage(index)"> -->
            </swiper-slide>
          </swiper>
        </div>
        <div class="small-images">
          <swiper 
          :modules="modules" 
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
          :loop="true"
          :slides-per-view="4" 
          :space-between="10" 
          @swiper="onSmallSwiper"
          @slideChange="onSlideChange" 
          :navigation="{
            enabled:true,
            hideOnClick:true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <img :src="image"
              :class="{ active: activeIndex === index }" 
              alt="Product Image"  
              @click="setActiveImage(index)">
            </swiper-slide>
            <div class="swiper-button-prev" @click="onPrev"></div>
            <div class="swiper-button-next" @click="onNext"></div>
          </swiper>
        </div>
      </div>
      <div v-if="!isReview" class="wp-relative" :style="{'margin-top': '20px'}" > 
        <div class="wp-reviews" @click="handlReview()"><h2>公主客评</h2></div>  
      </div> 
      
      <div v-if="!isReview" class="product-description">
        <h2>公主信息</h2>  
        <div class="wp-relative desc-detail">
          <div class="desc-item">名字： {{ currObj.title }}</div>
          <div class="desc-item">国籍： {{ currObj.nationality }}</div> 
          <div class="desc-item">年龄： {{ currObj.age }}</div>
          <div class="desc-item">身高： {{ currObj.stature }}</div>
          <div class="desc-item">体重： {{ currObj.weight }}</div>
          <div class="desc-item">胸围： {{ currObj.cir }}</div>
        </div>
      </div>
      <div v-if="!isReview" class="product-description">
        <h2>公主简介</h2>  
        <div class="wp-relative "   v-html="currObj.infocontent"> </div>
      </div>
    </div>
  </template>
  
<script>
import { ref, onMounted } from 'vue'; 
import { useRouter } from 'vue-router';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation,Autoplay,Pagination  } from 'swiper'; 

import 'swiper/css';
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 
import 'swiper/css/autoplay';


export default {
props: {
    images:{
        type:Array,
        default:() => []
    },
    currObj:{
      type:Object,
      default:() => {}
    },
    isReview:{
      type:Boolean,
      default:false
    }
},
components: {
    Swiper,
    SwiperSlide 
},
 
setup(pops) {
  const productName = '商品名称';
  const productDescription = '这里是商品的详细描述，可以包含多行文本。';
  const images3 = [
    require('@/assets/banner/bg.jpg'),
    require('@/assets/banner/bg2.jpg'),
  ];
  const activeIndex = ref(0);
  const bigSwiperInstance = ref(null);
  const smallSwiperInstance = ref(null); 
    

  const onNext = () =>{
      if (smallSwiperInstance.value) {
        smallSwiperInstance.value.slideNext(); 
        setActiveImage(smallSwiperInstance.value.realIndex);
      }
  };
  const onPrev = () =>{
      if (smallSwiperInstance.value) {
        smallSwiperInstance.value.slidePrev();
        activeIndex.value = smallSwiperInstance.value.realIndex;
        setActiveImage(smallSwiperInstance.value.realIndex);
      }
  }; 
  const onBigSwiper = (swiper) => { 
      bigSwiperInstance.value = swiper; 
    };

    const onSmallSwiper = (swiper) => { 
      smallSwiperInstance.value = swiper;
    };
  const onSlideChange = () => {
    // console.log('Slide changed');
  };

  const setActiveImage = (index) => {
    activeIndex.value = index;
    // console.log("---" +index);
    // 切换到指定的幻灯片
    if (bigSwiperInstance.value) {
      bigSwiperInstance.value.slideTo(index, 500, true);
      }
  };
  
  const router = useRouter();
  const   handlReview = () => { 
    // console.log('---title',pops.currObj.title)
    let _title = pops.currObj.title;
    router.push({ name: 'Review', params: { pid: pops.currObj.id}, query: { title: _title } }); 
  };
  

  onMounted(()=>{
    // console.log('rid---- '+ rid.value); 
  });
  return {
    productName,
    productDescription, 
    activeIndex,
    images3,   
    onNext,
    onPrev, 
    setActiveImage,
    onBigSwiper,
    onSmallSwiper,
    onSlideChange,
    handlReview, 
    modules: {Navigation, Autoplay,Pagination} 
  };
}
};
</script>
    
<style lang="scss" scoped>
@import url(@/assets/css/commPage.scss);
  
.product-detail {
    max-width: 800px;
    margin: 0 auto; 
} 
.wp-reviews{ 
  background-color: #040435;
  font-weight: normal;
  border-radius: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 80%;
  margin: auto;
  color: var(--wp--preset--color--accent);
  border: #007bff 1px solid;
  &:hover{
    cursor: pointer;
  }
}
.image-container {
margin: auto;
}
 
.big-image {
  position: relative;
  z-index: 1;
  padding-top: 30px;
  padding-bottom:3px;
  width: 100%;
  max-width: 450px;
  margin: 0 auto; 
}
    
.small-images {  
  width: 100%;
  max-width: 450px;
  margin: auto; 
}
.swiper-button-prev{
  background-color: transparent;
}

.swiper-slide img {
    width: 100%;
    cursor: pointer;
}

.active {
border: 2px solid #007bff;
}

.product-description {
margin-top: 20px;
}
.desc-detail{
  display: flex;
  flex-wrap: wrap;
}
.desc-item{ 
  text-align: left;
  color: #ffefbf;
  font-size: 17px;
  width: 40%;
  margin-left: 5%;
  padding: 0.6rem 0rem;
}
.product-description h2 {
margin-bottom: 10px;
}
</style>